<template>
  <div class="myTable">
    <div class="searchNav1" >
      <el-button class="newAdd" type="primary" @click="addOpt()" icon="el-icon-plus" v-if="$can('auth-user:add')">新增用户</el-button>
      <span><span class="searchNameStyle">姓名 ：</span><el-input style="width: 15%;" v-model="searchInfo.name" clearable placeholder="请输入"></el-input></span>
      <span><span class="searchNameStyle">手机号码 ：</span><el-input style="width: 15%;" v-model="searchInfo.account" clearable placeholder="请输入"></el-input></span>
      <span><span class="searchNameStyle">角色：</span>
                <el-select v-model="searchInfo.role" clearable  @change="search" placeholder="请选择">
                    <el-option
                            v-for="(item, i) in roleList"
                            :key="i"
                            :label="item.role"
                            :value="item.id">
                    </el-option>
                </el-select>
            </span>
      <span><span class="searchNameStyle">业务归属：</span>
                <el-select v-model="searchInfo.authUserId" clearable  @change="search" placeholder="请选择">
                    <el-option
                            v-for="(item, i) in partnerList"
                            :key="i"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName">
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="name" label="姓名" ></el-table-column>
        <el-table-column prop="roleList[0].role" label="角色"></el-table-column>
        <el-table-column prop="partnerName" label="业务归属" >
            <template slot-scope="scope">
                {{ scope.row.partnerName == null?"--":scope.row.partnerName }}
            </template>
        </el-table-column>
        <el-table-column prop="account" label="手机号码"  ></el-table-column>
        <el-table-column prop="city" label="地区" ></el-table-column>
        <el-table-column prop="address" label="详细地址" ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" ></el-table-column>
        <el-table-column prop="updateTime"  label="修改时间" ></el-table-column>
        <el-table-column prop="enabled" label="状态">
          <template slot-scope="scope">
            {{ scope.row.enabled | showState1 }}
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('auth-user:edit')" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:disable')" @click="confirmChangeState(scope.row)">{{scope.row.enabled |showState }}</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:resetPassword')"@click="confirmResetPassword(scope.row)">重置密码</el-button>
            <el-button type="text" size="small" v-if="$can('auth-user:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <el-form :model="addInfo" :rules="rules" ref="form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="用户姓名:" prop="name">
                <el-input v-model="addInfo.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码:" prop="account">
                <el-input v-model="addInfo.account" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="角色：" prop="roleId">
                <el-select v-model="addInfo.roleId" clearable @change="handleRoleChange" placeholder="请选择">
                  <el-option
                          v-for="(item, i) in roleList"
                          :key="i"
                          :label="item.role"
                          :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务归属:" prop="authUserId" v-if="addInfo.roleId == 20">
                <el-select v-model="addInfo.authUserId"  clearable  placeholder="请选择">
                  <el-option
                          v-for="item in dealOtherList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地区:" prop="district">
                <el-cascader
                        style="width: 250px;"
                        clearable
                        :options="options"
                        v-model="currentCity"
                        @change="handleChange">
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="详细地址:" prop="address">
                <el-input v-model="addInfo.address" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import { regionData, codeToText, TextToCode } from 'element-china-area-data'
  import Vue from 'vue'
  export default {
    name: "white-list",
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'新增用户',
        total:1,
        tableData: [],
        loading: false,
        dialogVisible: false,
        otherList:[],
        dealOtherList:[],
        partnerList:[], // 合伙人
        currentPage:1,
        roleList: [],
        currentCity:[],
        addInfo:{
          authUserId:'',
          account:'',
          roleId:'',
          gg:'',
          name:'',
          province:'',
          city:'',
          district:'',
          address:'',
        },
        searchInfo:{
          name:'',
          account:'',
          authUserId:'',
          partnerId:'',
          pageNumber:1,
          pageSize:50,
        },
        options: regionData,
      rules: {
          name: [
              { required: true, message: '请输入', trigger: 'blur' }
          ],
        account: [
              { required: true, message: '请输入手机号码', trigger: 'blur' },
              { validator: (rule, value, callback) => {
                      if (!value) {
                          callback(new Error('请输入手机号码'));
                      } else if (!vm.validatePhoneNumber(value)) {
                          callback(new Error('输入的手机号码格式有误，请修改！'));
                      } else {
                          callback();
                      }
                  }, trigger: 'blur' }
          ],
          roleId: [
              { required: true, message: '请选择', trigger: 'blur' }
          ],
          district: [
              { required: true, message: '请输入', trigger: 'blur' }
          ],
          address: [
              { required: true, message: '请输入地址', trigger: 'blur' }
          ],
          authUserId: [
              { required: true, message: '请选择业务归属', trigger: 'blur', validator: (rule, value, callback) => {
                  if (vm.addInfo.roleId == 20) {
                      if (!value) {
                          callback(new Error('请选择业务归属'));
                      } else {
                          callback();
                      }
                  } else {
                      callback();
                  }
              }}
          ]
      },

      }
    },
    created: function () {
      this.pageInfo();
      this.getAllRole();
      this.getOtherList();
      this.getPartnerList();
    },
    watch: {
      'searchInfo.name'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.account'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
    },
    methods:{
      search(){
        this.pageInfo();
      },
      //改为全局方法
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      addOpt(){
        this.dialogVisible = true;
        this.currentCity=[];
        this.addInfo.roleId = '';
      },
      validate(){
        let flag = true;
        let msg  = "";
        if (this.addInfo.account.length < 3){
          flag = false;
          msg = " 账号长度至少 3 位 "
        }else if(this.addInfo.role === ""){
          flag = false;
          msg = " 角色不能为空 "
        }
        return {code:flag,msg:msg}
      },
      save(){
        this.addInfo.district = JSON.stringify(this.currentCity);

        this.$refs.form.validate((valid) => {
          if (valid) {
            // 构建要发送的数据
            const dataToSend = {...this.addInfo};
            // 确保roleId是以正确的格式发送
            if (dataToSend.roleId) {
              dataToSend.roleIds = [dataToSend.roleId];
            }

            if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
              axios.post('/user', dataToSend).then(result => {
                this.dialogVisible = false;
                if (result.code !== 200){
                  console.log(result);
                }
                this.clearObj(this.addInfo); // 清空新增数据
                this.pageInfo();
              }).catch(err => {
                console.log(err);
              });
            }else{  // 编辑
              axios.put('/user/edit', dataToSend).then(result => {
                this.dialogVisible = false;
                if (result.code !== 200){
                  console.log(result);
                  this.$message.error(result.msg || '修改失败');
                  return;
                }
                this.pageInfo();
                this.clearObj(this.addInfo); // 清空新增数据
                this.dialogTitle="新增用户";
                this.$message.success('修改成功');
              }).catch(err => {
                console.log(err);
                this.$message.error('修改失败');
              });
            }
          } else {
            return false;
          }
        });
      },
      remove(id){
        axios.delete('/user',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      confirmRemove(id){
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      edit(obj){

        // this.dialogTitle = "用户编辑";
        // this.dialogVisible = true;
        // this.addInfo = JSON.parse(JSON.stringify(obj));
        // this.addInfo.roleId =JSON.parse(JSON.stringify( obj.roleList[0].id));
        // // 将查询的 dealOtherList 过滤当前的数据
        // this.dealOtherList = [];
        // this.otherList.forEach(item=>{
        //   if (item.key != obj.id) {
        //     this.dealOtherList.push(item);
        //   }
        // })
        // // 处理地区 将字符串转数组
        // this.currentCity = JSON.parse(this.addInfo.district);


        this.dialogTitle = "用户编辑";
        this.dialogVisible = true;
        this.addInfo = JSON.parse(JSON.stringify(obj));
        if (obj.roleList && obj.roleList.length > 0) {
          Vue.set(this.addInfo, 'roleId', obj.roleList[0].id);
        }
        this.dealOtherList = [];
        this.otherList.forEach(item=>{
          if (item.key != obj.id) {
            this.dealOtherList.push(item);
          }
        })
        this.currentCity = JSON.parse(this.addInfo.district);
      },
      confirmChangeState(obj){
        let operation = obj.enabled?"禁用":"开启";
        this.$confirm('确定要'+operation+obj.account+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeState(obj.id);
          this.$message({
            type: 'success',
            message: operation+'成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+operation
          });
        });
      },
      changeState(id){
        axios.put("/user/disable",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      getOtherList(){
        axios.get('/user/partnerList',{
          params: {}
        }).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.otherList = result.data;
          console.info("this.otherList",this.otherList);
          // 将查询的 dealOtherList 过滤当前的数据
          this.dealOtherList = [];
          this.otherList.forEach(item=>{
              this.dealOtherList.push(item);
          })
        }).catch(err => {
          console.log(err);
        });
      },
      getPartnerList(){
        axios.get('/user/partnerList',{
          params: {}
        }).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.partnerList = result.data;
          console.info("this.partnerList",this.partnerList);
        }).catch(err => {
          console.log(err);
        });
      },
      confirmResetPassword(obj){
        this.$confirm('确定要重置员工的密码，重置后密码：12345678 , 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.resetPassword(obj.id);
          this.$message({
            type: 'success',
            message: '重置密码成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置密码'
          });
        });
      },
      resetPassword(id){
        axios.put("/user/reset",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      pageInfo(){
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/user',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;
          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },
      getAllRole(){
        axios.get('/role-all',{
          params: {}
        }).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.roleList = result.data;
          console.info("===== this.roleList:"+this.roleList);
        }).catch(err => {
          console.log(err);
        });
      },
      // 在获取详情信息接口中使用 TextToCode 将字符串转换成编码赋给 selectedOptions
      handleChange (value) {
        console.log(value)
        let numberArray = value.map(Number);
        this.getCodeToText(null, numberArray)
      },
      getCodeToText (codeStr, codeArray) {
        if (null === codeStr && null === codeArray) {
          return null;
        } else if (null === codeArray) {
          codeArray = codeStr.split(",");
        }
        let area = "";
        switch (codeArray.length) {
          case 1:
            area += codeToText[codeArray[0]];
            break;
          case 2:
            area += codeToText[codeArray[0]] + "/" + codeToText[codeArray[1]];
            break;
          case 3:
            area +=
                    codeToText[codeArray[0]] +
                    "/" +
                    codeToText[codeArray[1]] +
                    "/" +
                    codeToText[codeArray[2]];
            break;
          default:
            break;
        }
        console.log(area)
        this.addInfo.city = area
        return area;
      },
      handleRoleChange(value) {
        this.addInfo.roleId = value;
        if (value !== 20) {
          this.addInfo.authUserId = '';
        }
      },
    },filters: {
      showSite(val){
        if (val){
          return "在职";
        }
        return "离职"
      },
      showState(val){
        if (val){
          return "禁用";
        }
        return "可用"
      },
      showState1(val){
        if (val){
          return "可用";
        }
        return "禁用"
      }
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
</style>
